import api from '@motionelements/core/src/api/base-api-v2';
import loadingMutation from '@motionelements/core/src/store/mutations-mixins/loadingMutation.js';
import { get } from 'lodash';

const state = () => ({
  list: [],
  loading: false,
  isLoaded: false,
  internalTools: [
    'image_variations',
    'background_remover',
    'face_swap',
    'music_duration',
    'style_transfer',
    'video_scriptwriter',
    'video_upscaler',
  ],
});

const getters = {
  aiToolsReleased(state) {
    return state.list.filter(({ released }) => released);
  },
  aiToolModels(state) {
    // eslint-disable-next-line
    return (toolId) => {
      const tool = state.list.find(({ id }) => id === toolId);
      // @todo pending optional chaining
      const models = get(tool, 'models', []) || [];
      return models.map(({ id, name, recommended }) => ({
        id,
        value: id,
        label: name,
        recommended,
      }));
    };
  },
};

const actions = {
  async getAiTools({ commit }, params) {
    commit('setLoading', true);
    return api.get('/v3/tools', { params })
      .then((response) => {
        commit('setAiTools', response.data.data);
        commit('setIsLoaded', true);
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

const mutations = {
  setAiTools(state, array) {
    state.list = array;
  },
  setIsLoaded(state, boolean) {
    state.isLoaded = boolean;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: {
    ...mutations,
    ...loadingMutation,
  },
};
